import React from "react";
import { Sparkles } from "lucide-react";
import { useLoginPrompt } from "../lib/loginPrompt";

/**
 * Top-of-app banner shown only in demo mode. Calls global LoginRequiredModal.
 */
export default function DemoBanner() {
  const { requireLogin } = useLoginPrompt();
  return (
    <div
      data-testid="demo-banner"
      className="bg-gradient-to-r from-emerald-500 via-emerald-500 to-teal-500 text-white"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3 px-4 py-2 text-xs sm:text-sm">
        <div className="flex items-center gap-2 min-w-0">
          <Sparkles className="w-3.5 h-3.5 shrink-0" strokeWidth={2.4} />
          <span className="truncate">
            You're viewing a demo - <span className="hidden sm:inline">login to use your own data.</span>
            <span className="sm:hidden">login to use your data.</span>
          </span>
        </div>
        <button
          type="button"
          onClick={() => requireLogin("Login to use your own data")}
          data-testid="demo-banner-login-btn"
          className="shrink-0 bg-white text-emerald-700 hover:bg-white/90 transition-colors font-semibold rounded-md px-3 py-1 text-xs"
        >
          Login
        </button>
      </div>
    </div>
  );
}
